export const socialAuthTypes = {
  metamaskSignIn: "metamask/sign-in",
  metamaskSignUp: "metamask/sign-up",
  googleSignIn: "google/sign-in",
  googleSignUp: "google/sign-up",
};

export const usernameSignIn = "username/sign-in";

export const socialTypes = {
  1: "facebook",
  2: "instagram",
  3: "snapchat",
  4: "twitter",
  5: "tiktok",
  6: "youtube",
  7: "twitch",
  8: "linkedIn",
  9: "soundCloud",
};

export const socialTypesMap = Object.fromEntries(
  Object.values(socialTypes).map((type) => [type, type]),
);

export const socialTypesByName = Object.fromEntries(
  Object.entries(socialTypes).map((pair) => pair.reverse()),
);
